import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import projectTargetService from '../services/project-target.service';
import { ProjectTargetUpdateRequestDto } from '../dto/request/project-target-update-request.dto';
import { ProjectTargetSaveRequestDto } from '../dto/request/project-target-save-request.dto';
import { ProjectTargetResponseDto } from '../dto/response/project-target-response.dto';

const initialState = {
  status: 'idle',
  projectTargets: [] as ProjectTargetResponseDto[] | null,
  projectTarget: {} as ProjectTargetResponseDto | null,
  error: null as string | null,
};

// export const fetchProjectTargetById = createAsyncThunk(
//   'projectTargets/fetchProjectTargetById',
//   async (id: string) => {
//     return await projectTargetService.fetchProjectTargetById(id);
//   }
// );

export const fetchProjectTargetsByProjectId = createAsyncThunk(
  'projectTargets/fetchProjectTargetsByProjectId',
  async (projectId: string) => {
    return await projectTargetService.fetchProjectTargetsByProjectId(projectId);
  }
);

export const saveProjectTarget = createAsyncThunk(
  'projectTargets/saveProjectTarget',
  async (saveRequest: ProjectTargetSaveRequestDto) => {
    return await projectTargetService.saveProjectTarget(saveRequest);
  }
);

export const updateProjectTarget = createAsyncThunk(
  'projectTargets/updateProjectTarget',
  async (updateRequest: ProjectTargetUpdateRequestDto) => {
    return await projectTargetService.updateProjectTarget(updateRequest);
  }
);

export const deleteProjectTarget = createAsyncThunk(
  'projectTargets/deleteProjectTarget',
  async (payload: { existingId: string; compactId: string | null }) => {
    return await projectTargetService.deleteProjectTarget(
      payload.existingId,
      payload.compactId
    );
  }
);

const projectTargetSlice = createSlice({
  name: 'projectTargetSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectTargetsByProjectId.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProjectTargetsByProjectId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectTargets = action.payload;
      })
      .addCase(fetchProjectTargetsByProjectId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      // .addCase(fetchProjectTargetById.pending, (state) => {
      //   state.status = 'loading';
      // })
      // .addCase(fetchProjectTargetById.fulfilled, (state, action) => {
      //   state.status = 'succeeded';
      //   state.projectTarget = action.payload;
      // })
      // .addCase(fetchProjectTargetById.rejected, (state, action) => {
      //   state.status = 'failed';
      //   state.error = action.error?.message ?? null;
      // })
      .addCase(saveProjectTarget.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(saveProjectTarget.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.projectTargets?.push(action.payload);
      })
      .addCase(saveProjectTarget.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(updateProjectTarget.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateProjectTarget.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.projectTargets) {
          const projectTargetIndex = state.projectTargets.findIndex(
            (projectTarget) => projectTarget.id === action.payload.id
          );
          if (projectTargetIndex !== -1) {
            state.projectTargets[projectTargetIndex] = action.payload;
          }
        }
      })
      .addCase(updateProjectTarget.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      })
      .addCase(deleteProjectTarget.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteProjectTarget.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteProjectTarget.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message ?? null;
      });
  },
});

export default projectTargetSlice.reducer;
